function WhyCapitol() {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-10">
          Why Capitol
        </h1>

        <p className="text-gray-700 mb-6">
          Capitol Public School offers a high-quality academic programme under
          CBSE curriculum designed to meet student needs.
        </p>

        <ul className="grid md:grid-cols-2 gap-6 text-gray-700">

          <li className="bg-white p-5 rounded-xl shadow">
            Skill development in communication, social & academic areas
          </li>

          <li className="bg-white p-5 rounded-xl shadow">
            Flexible curriculum across all levels
          </li>

          <li className="bg-white p-5 rounded-xl shadow">
            Continuous upgrade of facilities and teaching methods
          </li>

          <li className="bg-white p-5 rounded-xl shadow">
            Creative learning environment (classrooms, labs, sports)
          </li>

          <li className="bg-white p-5 rounded-xl shadow">
            Co-curricular & extracurricular activities
          </li>

          <li className="bg-white p-5 rounded-xl shadow">
            Olympiads & competitive exams for knowledge growth
          </li>

        </ul>

      </div>
    </section>
  );
}

export default WhyCapitol;